/**
 * Tooltip class handles the display and hiding of tooltip dialogs.
 * It attaches click event listeners to tooltip trigger buttons and close buttons,
 * and manages the opening and closing of associated <dialog> elements within tooltip containers.
 *
 * @class Tooltip
 * @constructor
 */
class Tooltip {
  constructor() {
    this.buttons = document.querySelectorAll('.tooltip__button');
    this.closeButtons = document.querySelectorAll('.tooltip__close-button');
    this.openTooltip = this.openTooltip.bind(this);
    this.closeTooltip = this.closeTooltip.bind(this);
  }

  /**
   * Initializes tooltip functionality by attaching click event listeners
   * to tooltip trigger buttons and close buttons.
   * 
   * - Adds a click event listener to each button in `this.buttons` to open the tooltip.
   * - Adds a click event listener to each button in `this.closeButtons` to close the tooltip.
   */
  init() {
    this.buttons.forEach(button => {
      button.addEventListener('click', this.openTooltip);
    });
    this.closeButtons.forEach(button => {
      button.addEventListener('click', this.closeTooltip);
    });
  }

  /**
   * Opens a tooltip modal dialog when triggered by an event.
   *
   * @param {Event} event - The event object triggered by the user interaction.
   * @returns {void}
   */
  openTooltip(event) {
    const tooltipContainer = event.currentTarget.closest('.tooltip');
    const tooltipModal = tooltipContainer ? tooltipContainer.querySelector('dialog') : null;
    if (tooltipModal) {
      tooltipModal.showModal();
    }
  }

  /**
   * Closes the tooltip modal dialog associated with the event's current target.
   *
   * @param {Event} event - The event object triggered by the user action.
   * The function locates the closest ancestor with the class 'tooltip' from the event's current target,
   * finds a <dialog> element within it, and closes the dialog if found.
   */
  closeTooltip(event) {
    const tooltipContainer = event.currentTarget.closest('.tooltip');
    const tooltipModal = tooltipContainer ? tooltipContainer.querySelector('dialog') : null;
    if (tooltipModal) {
      tooltipModal.close();
    }
  }
}

export default Tooltip;